let axios =require('axios');
var ShortId = require('id-shorter');


module.exports = {

    currentSocketConnection:null,

    cleanRut: function (rut) {
        return rut.replace('-','');
    },

    fmtClNumber: (number) =>{
        return new Intl.NumberFormat('es-CL', {
            currency: 'CLP'
        }).format(Number(number));
    },

    fmtClAmmount: (number) => {
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP'
        }).format(Number(number));
    },

    fdtCL: function (date) {
        var dateObj = new Date(date);
        return Intl.DateTimeFormat("es-CL", {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        }).format(dateObj);
    },

    ftCL: function (date) {
        console.log("----->",date);
        var dateObj = new Date(date);
        return Intl.DateTimeFormat("es-CL", {
            hour: 'numeric',
            minute: 'numeric'
        }).format(dateObj);
    },

    ftWsCL: function (date) { //time with seconds
        var dateObj = new Date(date);
        return Intl.DateTimeFormat("es-CL", {
            hour: 'numeric',
            minute: 'numeric',
            second:'numeric'
        }).format(dateObj);
    },

    isoDateToDateTime: (s)=>{
        const fdtCL=function (date) {
            var dateObj = new Date(date);
            return Intl.DateTimeFormat("es-CL", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }).format(dateObj);
        }

        if(s!=undefined){
            var b = (String(s)).split(/\D+/);
            return fdtCL(new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6])));
        } else {
            return null;
        }
    },

    fdCL: function (date) {
        if (date === null || date === undefined) {
            return '';
        }

        let dateObj = new Date(date);
        return Intl.DateTimeFormat("es-CL", {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        }).format(dateObj);
    },

    formatTimeCl: (date) => {
        let d = new Date(date);
        let options = {
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false,
            timeZone: 'America/Santiago'
        };
        return new Intl.DateTimeFormat('es-CL', options).format(d);
    },

    YYYYMMDD2DDMMYYYY:(stringDate)=> stringDate.split("-").reverse().join("-"),

    /*
    * converts string date to js date
    * stringDate: string with format "YYYYMMDD" or "YYYY-MM-DD"
    */
    YYYYMMDD2JsDate: (stringDate) => {
        const cleanStringDate = stringDate.replaceAll('-', '');
        const year = +cleanStringDate.substring(0, 4);
        const month = +cleanStringDate.substring(4, 6);
        const day = +cleanStringDate.substring(6, 8);

        const date = new Date(year, month - 1, day);
        return date;
    },

    clientIsBlocked:(client)=>{
        if (client?.blockedCode && client?.blockedLimit === null){
            return true;
        } else if (client?.blockedCode && client?.blockedLimit === undefined) {
            return true; 
        } else if (client?.blockedCode && client?.blockedLimit === '') {
            return true; 
        } else if (client?.blockedCode && module.exports.YYYYMMDD2JsDate(client?.blockedLimit) >= new Date()){
            return true;
        } else if (client?.lastTaskDateInSameWeek){
            return true;
        } else{
            return false;
        }
    },

    addDays : (date, days) =>{
        let dateCalc = new Date(date.valueOf());
        dateCalc.setDate(dateCalc.getDate() + days);
        return dateCalc;
    },

    findElementByKey: function(obj, key, value){
        for (var i = 0; i < obj.length; i++) {
            if (obj[i][key] === value) {
                return obj[i];
            }
        }
    },

    locationIsClientRecord : (strLocation) => {
        let splittedValues = strLocation.split('/');
        let checkForMDBOBJIDRegExp = /^[a-f\d]{24}$/i //<--- regex for a mongoDb objectId
        let checkRutRegExp = /^([0-9]+-[0-9Kk])$/i; //<--- regex for chilean rut

        if (splittedValues.length === 3 || splittedValues.length === 4) {
            if (checkForMDBOBJIDRegExp.test(splittedValues[1]) && checkRutRegExp.test(splittedValues[2])) {
                return true;
            }
        }

        return false;
    },


    isEmpty:(obj)=>{
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    },  

    getFieldDesc: function (arrayOfTaskFields, taskFieldName) {
        let taskFieldFound = arrayOfTaskFields.filter(taskField => taskField.name === taskFieldName);
        return taskFieldFound[0].label;
    },
    
    logout: function(history){
        alert('Se sesión de usuario ha finalizado, es necesario que vuelva a iniciar sesión.');
        sessionStorage.clear();
        history.push('/login');
    },

    forceLogout: function(history){
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/forceLogout`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            sessionStorage.clear();
            history.push('/login');
        });
    },

    logoutWM: function(history){ //without message
        sessionStorage.clear();
        history.push('/login');
    },

    getPriorityPhone: function(contactPhones){
        // if (contactPhones.telefono1 !== null && contactPhones.telefono1 !== "null"){
        //     return contactPhones.telefono1;
        // } else if (contactPhones.telefono2 !== null && contactPhones.telefono2 !== "null") {
        //     return contactPhones.telefono2;
        // } else if (contactPhones.telefono3 !== null && contactPhones.telefono3 !== "null") {
        //     return contactPhones.telefono3;
        // } else if (contactPhones.telefono4 !== null && contactPhones.telefono4 !== "null") {
        //     return contactPhones.telefono4;
        // } else if (contactPhones.telefono5 !== null && contactPhones.telefono5 !== "null") {
        //     return contactPhones.telefono5;
        // } else if (contactPhones.telefono6 !== null && contactPhones.telefono6 !== "null") {
        //     return contactPhones.telefono6;
        // } else {
        //     return "SIN TELEFONO";
        // }

        // let i=1;
        // while (i <= 15) {
        //     let currentPhone=contactPhones[`telefono${i}`];
        //     if (currentPhone && currentPhone!==null && currentPhone!=="null" && currentPhone!==""){
        //         return currentPhone;
        //     }
        //     i++;
        // }
        // return "SIN TELEFONO";

        return contactPhones[0];
    },

    shortCode:function(longId){
        var mongoDBId = ShortId({
            isFullId: true
        });
        var shortId = mongoDBId.encode(longId);
        return shortId;
    },

    loginSoftphone: (softphone, currentUser)=>{
    },

    logUserStatus : (status) => {
        var promiseLogUserStatus = new Promise(function (resolve, reject) {
            try {
                let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
                const options = {
                    url: `${process.env.REACT_APP_URI_API_CRM}/userStatus`,
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': currentSessionData.token
                    },
                    data: { eventCode: status.code, eventDesc: status.desc}
                };

                axios(options).then(response => {
                    if (response.status === 200) {
                        console.log('User event logged');
                        resolve('OK');
                    }
                }).catch(function (error) {
                    reject(error);
                });
            } catch (error) {
                //reject('ERROR');
                reject(error);
            }
        });

        return promiseLogUserStatus;
    },


    connectClientToSocket: (socketIOClient, extension, username, profileCode, hostId, connectionRequestedFrom='' ) =>{
        //console.log('🐞DEBUG connectionRequestedFrom:', connectionRequestedFrom);
        const SOCKETIO_SERVER_URI = process.env.REACT_APP_SOCKETIO_SERVER_URI;
        let socket='';
        if (process.env.REACT_APP_SOCKETIO_SERVER_PATH.trim()===''){ 
            //socket = socketIOClient(SOCKETIO_SERVER_URI ,{query: `crmSocketClientId=${extension}`});
            socket = socketIOClient(SOCKETIO_SERVER_URI ,{query: `crmSocketClientId=${extension}&username=${username}&profileCode=${profileCode}&hostId=${hostId}`});
        } else { //ADD PATH TO SOCKET URL + QUERY PARAMS
            //socket = socketIOClient(SOCKETIO_SERVER_URI, { "path": process.env.REACT_APP_SOCKETIO_SERVER_PATH, query: `crmSocketClientId=${extension}` });
            socket = socketIOClient(SOCKETIO_SERVER_URI, { "path": process.env.REACT_APP_SOCKETIO_SERVER_PATH, query: `crmSocketClientId=${extension}&username=${username}&profileCode=${profileCode}&hostId=${hostId}` });
        }

        return socket;
    },

    boxLog:(strContent)=>{
        let rows = strContent.split(/\r?\n/);
        rows = rows.map(r => r.trim());
        const longestLine = rows.reduce((acc, val) => { return acc.length > val.length ? acc : val; });
        console.log(`╭${"─".repeat(longestLine.length + 4)}╮`);
        rows.forEach((line, index) => {
            console.log(`│  ${line}${" ".repeat((longestLine.length - line.length) + 2)}│`);
        });
        console.log(`╰${"─".repeat(longestLine.length + 4)}╯`);
    },



elapsedTime:(d, dd) => {
    var minute = 60 * 1000,
        hour = minute * 60,
        day = hour * 24,
        month = day * 30,
        ms = Math.abs(d - dd);

    var months = parseInt(ms / month, 10);
        ms -= months * month;

    var days = parseInt(ms / day, 10);
        ms -= days * day;
    
    var hours = parseInt(ms / hour, 10);
        ms -= hours * hour;
    var minutes = parseInt(ms / minute, 10);

    let result=[
        //months>0?months + " meses":null,
        days>0?days + " dias":null,
        hours>0?hours + " hrs":null,
        minutes>0?minutes + " mins":null
        
    ].filter(r => r !== null).join(", ");

    if (result.length===0){result=['Un instante']}

    return result;
},


customLocaleSpanish:{
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',],

        weekDays: [{ name: 'Lunes', short: 'L', }, { name: 'Martes', short: 'M', }, { name: 'Miércoles', short: 'M', }, { name: 'Jueves', short: 'J', }, { name: 'Viernes', short: 'V', }, { name: 'Sábado', short: 'S', isWeekend: true, }, { name: 'Domingo', short: 'D', isWeekend: true, },],
        weekStartingIndex: 6,
        getToday(gregorainTodayObject) {
            return gregorainTodayObject;
        },

        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day);
        },

        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate();
        },

        transformDigit(digit) {
            return digit;
        },

        // texts in the date picker
        nextMonth: 'Próximo mes',
        previousMonth: 'Mes anterior',
        openMonthSelector: 'Selector de mes',
        openYearSelector: 'Selector de año',
        closeMonthSelector: 'Cerrar selector de mes',
        closeYearSelector: 'Cerrar selector de año',
        defaultPlaceholder: 'Seleccionar...',

        // for input range value
        from: 'Del',
        to: 'al',


        // used for input value when multi dates are selected
        digitSeparator: ',',

        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,

        // is your language rtl or ltr?
        isRtl: false,
    
},

    getNowForRMCD: () => {
        let d = new Date();
        var mm = d.getMonth() + 1;
        var dd = d.getDate();
        return { year: d.getFullYear(), month: mm, day: dd }
    },
    
     getYMD:(d) => {
        var mm = d.getMonth() + 1;
        var dd = d.getDate();
        return [d.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
    }

};
